import Constants from '@/common/constants';

export const TRADE_MAP_COLORS = {
  NO_DATA: '#e3e3e3',
  SELECTED_COUNTRY: '#000000',
  BORDER: '#ffffff',
  OUTLINE: '#ffffff',
};

// Базовые цвета потоков — на середине диапазона долей
// export — #277cc5, import — #01808f
export const TRADE_BASE_HSL = {
  [Constants.tradingOperation.export]: { h: 207, s: 67, l: 46 },
  [Constants.tradingOperation.import]: { h: 186, s: 99, l: 28 },
};

export const SHARE_LIGHTNESS = {
  pale: 88,
  deep: 20,
};

// Доли значения для выбора цвета остановок легенды
export const LEGEND_STOPS = [0, 0.002, 0.02, 0.05, 0.1, 0.25, 0.5, 0.75, 1];

// Доли ширины полосы для тех же остановок
export const LEGEND_POSITIONS = [0, 0.03, 0.1, 0.18, 0.25, 0.44, 0.63, 0.82, 1];

export const TRADE_MAP_ERRORS = {
  400: 'Проверьте выбранные фильтры',
  404: 'Страна не найдена. Проверьте выбранный фильтр',
  500: 'Сервер недоступен',
  EMPTY: 'Нет данных для отображения',
};
